/**
 * @date 03/14/2017
 * @copyright 2015 Empower Retirement
 * @description
 *
 * The transaction messages component is an optional column that's used within AccountDetailsView. It's possible
 * this component will be required in other projects in the future so it's a reusable component. The component
 * knows how set it's column CSS and calls the API for messages in the corresponding controller.
 *
 * @example
 *
 *      <transaction-messages></transaction-messages>
 */
import transactionMessagesViewTemplate from "./TransactionMessagesViewTemplate";
import TransactionMessagesController from "./TransactionMessagesController";

var TransactionMessagesDirective = function () {
    return {
        restrict: "E",
        template: transactionMessagesViewTemplate,
        scope: {
            activeGroupId: "=",
            disableScroll: "=disableScroll",
            layoutPosition: "@",
            useAccountDetailsLayout: "@"
        },
        controller: TransactionMessagesController,
        controllerAs: "transactionMessagesController"
    };
};

export default TransactionMessagesDirective;
